import { isTempId } from 'api/common';
import { filterDuplicateData } from 'redux/modules/sections';
import { updateSettings } from 'redux/modules/settings';
import { setChangedIDs } from 'redux/modules/changedFields';

import { getChangeItems, filterTempDelete } from 'editor/components/Navbar/Button/saveData';
import { OPTIONS_TYPE } from 'common/utils/config';
import i18n from 'i18next';

export const REPLACE_OPTIONS = 'REPLACE_OPTIONS';
const ADD_OPTION = 'ADD_OPTION';
const UPDATE_OPTION = 'UPDATE_OPTION';
const DELETE_OPTION = 'DELETE_OPTION';
const DELETE_CHILD_OPTIONS = 'DELETE_CHILD_OPTIONS';
const UPDATE_TEMPID_OPTION = 'UPDATE_TEMPID_OPTION';
const ADD_GlobalSection_Options = 'ADD_GlobalSection_Options';
const UPDATE_OPTION_RELATED = 'UPDATE_OPTION_RELATED';
const DELETE_OTHER_OPTIONS = 'DELETE_OTHER_OPTIONS';

export default function options(state = [], action) {
    switch (action.type) {
        case REPLACE_OPTIONS:
            return action.payload;
        case ADD_OPTION: {
            const { fieldId, type = 1, ...restData } = action.payload.option;

            const newOption = {
                ...restData,
                fieldId,
                type,
                seq: 0 // placeholder，稍後會重排
            };

            // 插入位置判斷
            let insertIndex = -1;

            if (type === OPTIONS_TYPE.NORMAL) {
                insertIndex = state.findIndex(
                    option =>
                        option.fieldId === fieldId &&
                        (option.type === OPTIONS_TYPE.NORMAL_OTHER ||
                            option.type === OPTIONS_TYPE.TWO_LEVEL_OTHER)
                );
                if (insertIndex === -1) {
                    insertIndex = state.length;
                }
            } else {
                insertIndex = state.length;
            }

            const updated = [...state];
            updated.splice(insertIndex, 0, newOption);

            // 針對該 fieldId 的項目重排 seq
            const resequenced = updated.map((item, _, arr) => {
                if (item.fieldId !== fieldId) return item;

                const indexInField = arr.filter(o => o.fieldId === fieldId).indexOf(item);
                return {
                    ...item,
                    seq: indexInField + 1
                };
            });

            return resequenced;
        }

        case UPDATE_OPTION: {
            const { optionId, label } = action.payload;
            return state.map(option => {
                if (option.id === optionId) {
                    // [866arrdu1] ticket: option 剛建立時，選項別名(ref)要帶預設值 null
                    return { ...option, label, ref: option?.ref ?? null };
                }
                return option;
            });
        }
        case DELETE_OPTION: {
            const { optionId, fieldId } = action.payload;
            const { options, otherOptions } = state.reduce(
                (obj, option) => {
                    if (option.fieldId !== fieldId) {
                        obj.otherOptions.push(option);
                    } else {
                        obj.options.push(option);
                    }
                    return obj;
                },
                {
                    options: [],
                    otherOptions: []
                }
            );
            const sortSeqOptions = options.reduce((arr, option) => {
                if (option.id === optionId) {
                    arr.push({ ...option, seq: arr.length + 1, deleted: 1 });
                } else {
                    arr.push({ ...option, seq: arr.length + 1 });
                }
                return arr;
            }, []);
            return [...sortSeqOptions, ...otherOptions];
        }
        case DELETE_CHILD_OPTIONS: {
            const { optionId } = action.payload;
            return state.reduce((arr, option) => {
                if (option.parentId === optionId) {
                    arr.push({ ...option, deleted: 1 });
                } else {
                    arr.push(option);
                }
                return arr;
            }, []);
        }
        case DELETE_OTHER_OPTIONS: {
            const { fieldId } = action.payload;
            return state.map(option => {
                if (
                    option.fieldId === fieldId &&
                    option.type === OPTIONS_TYPE.TWO_LEVEL_SECOND_OTHER
                ) {
                    return { ...option, deleted: 1 };
                }
                return option;
            });
        }
        case UPDATE_TEMPID_OPTION: {
            const { mapFields, mapOptions } = action.payload;
            const optionsReplaceTemp = state.map(option => {
                let newOption = option;
                if (mapFields[option.fieldId]) {
                    newOption = { ...newOption, fieldId: mapFields[option.fieldId] };
                }
                if (mapOptions[option.id]) {
                    newOption = { ...newOption, id: mapOptions[option.id] };
                }
                if (isTempId(option.parentId)) {
                    newOption = {
                        ...newOption,
                        parentId: mapOptions[option.parentId]
                    };
                }
                return newOption;
            });
            return optionsReplaceTemp;
        }
        case ADD_GlobalSection_Options: {
            const { options } = action.payload;
            const clearOptions = filterDuplicateData(state, options);
            return [...clearOptions, ...options];
        }
        case UPDATE_OPTION_RELATED: {
            const { optionId, resultPages } = action.payload;
            return state.map(option => {
                if (option.id === optionId) {
                    return { ...option, resultPages };
                }
                return option;
            });
        }
        default:
            return state;
    }
}

export function addOption(
    id,
    fieldId,
    parentId = undefined,
    resultPages = undefined,
    label = i18n.t('promo.option.name'),
    type = OPTIONS_TYPE.NORMAL
) {
    let data = {};
    if (resultPages) {
        data.resultPages = [];
    }
    return {
        type: ADD_OPTION,
        payload: { option: { id, fieldId, label, ref: null, parentId, type, ...data } }
    };
}

export function updateOption(optionId, { label }) {
    return {
        type: UPDATE_OPTION,
        payload: { optionId, label }
    };
}

export function deleteOption(optionId, fieldId) {
    return {
        type: DELETE_OPTION,
        payload: { optionId, fieldId }
    };
}

export function deleteChildOptions(parentId) {
    return {
        type: DELETE_CHILD_OPTIONS,
        payload: { optionId: parentId }
    };
}

export function deleteOtherOptions(fieldId) {
    return {
        type: DELETE_OTHER_OPTIONS,
        payload: { fieldId }
    };
}

export function updateTempIdOption(fields = {}, options = {}) {
    return {
        type: UPDATE_TEMPID_OPTION,
        payload: {
            mapFields: fields,
            mapOptions: options
        }
    };
}

export function addGlobalSectionOptions(options) {
    return {
        type: ADD_GlobalSection_Options,
        payload: { options }
    };
}

export function updateOptionRelated(optionId, resultPages) {
    return {
        type: UPDATE_OPTION_RELATED,
        payload: { optionId, resultPages }
    };
}

export function updateAllOptionsRelated(options, resultPages) {
    return dispatch => {
        options.map(option => dispatch(updateOptionRelated(option.id, resultPages)));
    };
}

export function updateRelationPageId(options, pages) {
    return dispatch => {
        options.map(option => {
            let isChanged = false;
            const resultPages = option.resultPages.map(relation => {
                if (pages[relation.id]) {
                    isChanged = true;
                    return { ...relation, id: pages[relation.id] };
                }
                return relation;
            });
            if (isChanged) {
                return dispatch(updateOptionRelated(option.id, resultPages));
            }
            return false;
        });
    };
}

export function updateRelationDeletedPageId(pageId) {
    return (dispatch, getState) => {
        const options = getState().options;
        options.map(option => {
            let isChanged = false;
            const resultPages = option.resultPages.filter(relation => {
                if (relation.id === pageId) {
                    isChanged = true;
                    return false;
                }
                return true;
            });
            if (isChanged) {
                return dispatch(updateOptionRelated(option.id, resultPages));
            } else {
                return false;
            }
        });
    };
}

export function updateFieldOptionsRandom({ options, fieldIds, callback }) {
    return (dispatch, getState) => {
        fieldIds.map(fieldId => dispatch(updateSettings('fields', fieldId, { relationType: 1 })));
        dispatch(setChangedIDs({ fieldsIds: fieldIds, options: true }));
        options.map(option => dispatch(updateOptionRelated(option.id, [])));

        const store = getState();
        const changedFields = getState().changedFields;
        const { promoSettings = {}, ...data } = getChangeItems(
            changedFields,
            filterTempDelete(store)
        );
        const { title, ...restPromoSettings } = promoSettings;
        const promoData = { setting: restPromoSettings, promotion: { title } };
        callback({ formData: data, promoData });
    };
}

export function replaceOption(payload) {
    return (dispatch, getState) => {
        const currentOptions = getState().options;

        // 過濾出不需要替換的選項
        const unchangedOptions = currentOptions.filter(
            option => !payload.some(newOption => newOption.id === option.id)
        );

        // 合併並排序
        const sortedOptions = [...unchangedOptions, ...payload].sort(
            (a, b) => a.fieldId - b.fieldId || a.seq - b.seq
        );

        dispatch({
            type: REPLACE_OPTIONS,
            payload: sortedOptions
        });
    };
}

export function replaceChildOption(payload, fieldList, selectedParentId) {
    return (dispatch, getState) => {
        const { options } = getState();
        const childOptions = options.filter(option => option.fieldId === fieldList[1].fieldId);
        const filteredChildOptions = childOptions.filter(
            option => option.parentId === selectedParentId && !option.deleted
        );
        // 建立新的 options 陣列：先移除舊的，再加入新的 payload
        const remainingOptions = options.filter(
            option => !filteredChildOptions.some(old => old.id === option.id)
        );

        const updatedOptions = [...remainingOptions, ...payload];

        dispatch(replaceOption(updatedOptions));
    };
}
